// Apply data-product-handle and data-variant-id to .nosto_carousel cards
(() => {
  const LOG = '[Nosto Abra]';
  const SEL = '.nosto_carousel li[data-product-identifier], .ul-container .nosto_carousel li[data-product-identifier], li[data-product-identifier]';

  const apply = () => {
    const cards = [...document.querySelectorAll(SEL)];
    const getHandle = (el) => el.getAttribute('p-handle') || el.getAttribute('data-display-url')?.match(/\/products\/([^\/\?#]+)/)?.[1] || el.querySelector('a[href*="/products/"]')?.href?.match(/\/products\/([^\/\?#]+)/)?.[1];
    cards.forEach((card) => {
      const handle = getHandle(card);
      if (!handle) return;
      card.setAttribute('data-product-handle', handle);
      const vid = card.querySelector('form input[name="id"]')?.value;
      if (vid) card.setAttribute('data-variant-id', vid);
      const pw = card.querySelector('.price-wrap');
      if (pw) pw.setAttribute('data-product-handle', handle), vid && pw.setAttribute('data-variant-id', vid);
    });
    return cards.length;
  };

  let applying = false, raf = null;
  const run = () => {
    if (applying) return;
    applying = true;
    try { apply(); window.Abra?.render?.(); } finally { requestAnimationFrame(() => applying = false); }
  };

  const onNosto = () => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => { raf = null; run(); });
  };

  const init = () => {
    run();
    const obs = new MutationObserver((muts) => {
      if (applying) return;
      const has = muts.some((m) => m.type === 'childList' && [...m.addedNodes].some((n) => n instanceof Element && (n.classList?.contains('nosto_carousel') || n.querySelector?.('.nosto_carousel') || n.matches?.('li[data-product-identifier]'))));
      if (has) onNosto();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
